// -----------------------------------------------------------
// FloraIQ - Methodology Reports Grid (Aba 9: Relatórios)
// -----------------------------------------------------------

import { type FC } from "react";
import { ladmReports } from "@/mocks/ladm";
import LadmStatusBadge from "./LadmStatusBadge";
import type { LadmBadgeVariant } from "./LadmStatusBadge";

const reportStatusMap: Record<string, LadmBadgeVariant> = {
  disponivel: "disponivel",
  processando: "processando",
  pendente: "pendente",
};

const reportIcons: Record<string, string> = {
  "Base Cadastral Arbórea Georreferenciada": "ri-database-2-line",
  "Mapa das Árvores Cadastradas": "ri-map-pin-line",
  "Mapa de Risco": "ri-error-warning-line",
  "Mapa de Recomendações de Poda e Manejo": "ri-scissors-line",
  "Mapa de Cobertura Vegetal": "ri-landscape-line",
  "Mapa de Espécies": "ri-plant-line",
  "Relatório por Bairro": "ri-building-2-line",
  "Relatório de Responsabilidades": "ri-shield-check-line",
  "Relatório de Restrições Ambientais": "ri-alert-line",
  "Relatório de Histórico de Manejo": "ri-history-line",
  "Relatório Técnico com Fontes e Evidências": "ri-folder-info-line",
  "Dashboard Gerencial": "ri-dashboard-line",
  "Banco de Imagens": "ri-image-line",
  "Nuvem de Pontos Processada": "ri-stack-line",
  "Modelo 3D da Arborização": "ri-shapes-line",
  "Plano Preliminar de Manejo": "ri-file-list-3-line",
};

const MethodsReportsGrid: FC = () => {
  return (
    <div className="space-y-6">
      <p className="text-sm text-foreground-600">
        Produtos gerados a partir da aplicação da metodologia FloraIQ-LADM. Relatórios, mapas, modelos e dados prontos para gestão municipal.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {ladmReports.map((report) => (
          <div key={report.id} className="bg-white rounded-card border border-background-200/70 p-4 flex flex-col hover:shadow-sm transition-shadow">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
                <i className={`${reportIcons[report.title] || "ri-file-text-line"} text-blue-600 text-sm`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-foreground-900 font-heading leading-snug">{report.title}</h4>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed line-clamp-2">{report.description}</p>
              </div>
            </div>

            <div className="flex items-center justify-between mt-auto pt-3 border-t border-background-200/50">
              <div className="flex flex-col gap-0.5">
                <LadmStatusBadge variant={reportStatusMap[report.status] || "pendente"} />
                {report.ultimaGeracao !== "-" && (
                  <span className="text-xs text-foreground-400 mt-1">
                    {new Date(report.ultimaGeracao + "T00:00:00").toLocaleDateString("pt-BR")}
                  </span>
                )}
              </div>
              <div className="flex items-center gap-1">
                {report.status === "disponivel" ? (
                  <button className="text-xs text-blue-600 hover:text-blue-700 cursor-pointer p-1 whitespace-nowrap" title="Visualizar">
                    <i className="ri-eye-line"></i>
                  </button>
                ) : report.status === "processando" ? (
                  <span className="text-xs text-blue-500 p-1">
                    <i className="ri-loader-4-line animate-spin"></i>
                  </span>
                ) : null}
                <button className="text-xs text-foreground-400 hover:text-foreground-600 cursor-pointer p-1 whitespace-nowrap" title="Gerar">
                  <i className="ri-play-circle-line"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MethodsReportsGrid;